module.exports = __webpack_public_path__ + "img/mk.f49662c5.jpg";